module.exports = __webpack_public_path__ + "static/media/login-bg-sarcopenia-ai.add973e3.png";